export const WIDGET_DATA_ENTITY_NAME = 'WidgetData';
export const FILTER_SELECTION_ENTITY_NAME = 'FilterSelection';
export const DASHBOARD_FILTERS_ENTITY_NAME = 'DashboardFilters';
export const WIDGET_FILTERS_ENTITY_NAME = 'WidgetFilters';
export const WIDGET_DATA_SETTINGS_ENTITY_NAME = 'WidgetDataSettings';
